enum OrderOption {
    Default = 0,
    Name = 1,
    Pricing = 2,
    Popularity = 3,
    LastSummoned = 4,
    Newest = 5
}

export default OrderOption;